import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { SpecCourseLessonViewTab } from 'common.components/spec-course-lesson-view/__tab/spec-course-lesson-view__tab';
import { SpecCourseLessonViewTabs as CommonSpecCourseLessonViewTabs } from 'common.components/spec-course-lesson-view/__tabs/spec-course-lesson-view__tabs';
import { SPEC_COURSE_LESSON_VIEW_TABS } from 'common.components/spec-course-lesson-view/typings';

import { specCourseActions } from '../../spec-course.store/actions';
import * as specCourseSelectors from '../../spec-course.store/selectors';
import * as lessonSelectors from '../../../../../common.components/lesson/selectors/common';

/** Табы, переключающие информацию о спецпроекте */
export const SpecCourseLessonViewTabs = () => {
    const dispatch = useDispatch();
    const tabSlug = useSelector(specCourseSelectors.getTab);
    const shouldShowDiagnosticsResults = useSelector(lessonSelectors.shouldShowDiagnosticsResults);

    const handleTabClick = (tab: SPEC_COURSE_LESSON_VIEW_TABS) => {
        ym('reachGoal', 'teacher_olymp_click_tab', { tab });

        dispatch(specCourseActions.setTab({ tab }));
    };

    return (
        <CommonSpecCourseLessonViewTabs>
            <SpecCourseLessonViewTab
                currentTab={tabSlug}
                onClick={handleTabClick}
                slug={SPEC_COURSE_LESSON_VIEW_TABS.RULES}
                textId="specCourseLessonView.tabs.rules"
            />
            <SpecCourseLessonViewTab
                currentTab={tabSlug}
                onClick={handleTabClick}
                slug={SPEC_COURSE_LESSON_VIEW_TABS.RESULTS}
                textId="specCourseLessonView.tabs.results"
            />
            {shouldShowDiagnosticsResults ? (
                <SpecCourseLessonViewTab
                    currentTab={tabSlug}
                    onClick={handleTabClick}
                    slug={SPEC_COURSE_LESSON_VIEW_TABS.DIAGNOSTICS_RESULTS}
                    textId="specCourseLessonView.tabs.diagnosticsResults"
                />
            ) : null}
        </CommonSpecCourseLessonViewTabs>
    );
};
